// // Remove from Wish List
function removeFromWishlist(productID) {
    if(Cookies.get("wishList") != undefined) {
        var wishList = jQuery.parseJSON(Cookies.get("wishList"));
        if(wishList != undefined && wishList.length != 0) {            
            var filtered = wishList.filter(function(item) { 
                return item !== productID;  
            });
            Cookies.remove('wishList');
            if(filtered.length == 0) {
                location.reload();
            }
            Cookies.set("wishList", JSON.stringify(filtered));
            jQuery('#remove-from-wishlist').addClass('hidden');
            jQuery('#add-to-wishlist').removeClass('hidden');
        }
    }

}

var placeholder = jQuery(".message.mailing .message_placeholder");

jQuery(document).ready(function($) {

    jQuery('.remove-from-wishlist').click(function(e) {
        e.preventDefault();
        removeFromWishlist($(this).data('id'));
        // $(this).closest('tr.wish-single').fadeOut().delay(100).remove();
        $(this).closest('tr.wish-single').fadeOut(300, function() { $(this).remove(); });
    })

    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
      
    // function validateE() {
    //     var $result = jQuery("#email-error");
    //     var email = jQuery("#email").val();
    //     $result.text("");
    //     return false;
    // }

    function validate() {
        //console.log('starting validate');
        if (!document.getElementById('name').value) {
            jQuery('#name-error').text("Please enter your name");
        } else if (!document.getElementById('phone').value) {
            jQuery('#phone-error').text("Please enter a valid phone number");
        } else if (!document.getElementById('email').value) {
            jQuery('#email-error').text("Please enter a valid email address");
        } else if (!validateEmail(document.getElementById('email').value)) {
            jQuery('#email-error').text("Please enter a valid email address");
        } else {
            onMailingSubmit();
        }
        // else {
        //     // updateButtonText('Validating...');
        //     grecaptcha.execute();
        // }
        
    }

    jQuery('#name').change(function() {
        jQuery('#name-error').text("");
    });

    jQuery('#phone').change(function() {
        jQuery('#phone-error').text("");
    });

    jQuery('#email').change(function() {
        jQuery('#email-error').text("");
    });


    // $( "#wish-submit" ).click(function(event) {
    //     console.log('starting click');
    //     event.preventDefault();
    //     validate();
    // });

});

function onMailingSubmit(token) {

    jQuery('#wish-submit').text('Submitting..');
    jQuery('#wish-submit').removeClass('btn-success');
    jQuery('#wish-submit').addClass('btn-info');
    var f = jQuery("#wishlist-form");

    var the_data = f.serializeArray();
    // the_data.push({name: 'recaptcha', value: token});

    jQuery.post(f.attr('action'), the_data, function(data) {
        // console.log(data);
        if (data.error == false) {
            placeholder.addClass('success');
            jQuery("#wishlist-form").css('display', 'none');
            f[0].reset();
            Cookies.remove('wishList');
        } else {
            placeholder.addClass('error');
        }

        updateButtonText(data.message);
        
    }, 'json');

    //json_enconde()
}


function updateButtonText(message) {
    var submitButton = jQuery(".message_placeholder");
    submitButton.html(message);
}